'use strict';

const jQuery = require('jquery');

const FormBuilder = require('./../builder');

let ElementClass = require('./../elementClass');

FormBuilder.register('password', function(config) {
    let self = {};

    self = new ElementClass(config);

    self.render = function(wrap) {
        let $element = jQuery('<input/>');
        let $label;

        $element.attr('type', 'password');
        $element.attr('name', self.name);
        $element.attr('disabled', self.disabled);

        if (undefined !== self.placeholder) {
            $element.attr('placeholder', self.placeholder);
        }

        if (self.value !== undefined && self.value !== null) {
            $element.val(self.value);
        }

        if (self.elementClass) {
            $element.addClass(self.elementClass);
        }

        if (config.autocomplete === false) {
            $element.attr('autocomplete', 'new-password');
            $element.attr('autocomplete', 'off');
        }

        if (typeof config.onChange === 'function') {
            $element.on('keyup', config.onChange);
        }

        if (self.label) {
            $label = jQuery('<label/>');

            if (self.labelClass) {
                $label.addClass(self.labelClass);
            }

            $label.text(self.label);

            wrap.append($label);
        }

        return $element;
    };

    self.getData = function() {
        return self.$.find('input:first').val();
    };

    return self;
});
